import React from 'react';

import COLORS from '../constants/colors';

function FilterCheckbox({ label, checked, onChange, description }) {
  const handleChange = (event) => {
    if (typeof onChange === 'function') {
      onChange(event.target.checked);
    }
  };

  return (
    <label
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '10px 14px',
        borderRadius: 12,
        border: `1px solid ${checked ? COLORS.MAIN_BLUE : COLORS.GRAY_OUTLINE}`,
        background: checked ? 'rgba(0, 48, 102, 0.08)' : COLORS.MAIN_WHITE,
        cursor: 'pointer',
        boxShadow: checked ? '0 4px 12px rgba(0, 48, 102, 0.12)' : 'none',
        transition: 'all 0.2s ease',
        userSelect: 'none',
      }}>
      <span
        style={{
          position: 'relative',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 20,
          height: 20,
        }}>
        <input
          type='checkbox'
          checked={checked}
          onChange={handleChange}
          style={{
            position: 'absolute',
            opacity: 0,
            pointerEvents: 'none',
          }}
        />
        <span
          style={{
            width: 18,
            height: 18,
            borderRadius: 5,
            border: `2px solid ${
              checked ? COLORS.MAIN_BLUE : COLORS.GRAY_OUTLINE
            }`,
            backgroundColor: checked ? COLORS.MAIN_BLUE : COLORS.MAIN_WHITE,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: COLORS.MAIN_WHITE,
            fontSize: 12,
            fontWeight: 700,
          }}>
          {checked ? '✓' : ''}
        </span>
      </span>
      <span
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: description ? 4 : 0,
          color: COLORS.MAIN_BLUE,
        }}>
        <span style={{ fontWeight: 600, fontSize: 13 }}>{label}</span>
        {description && (
          <span style={{ fontSize: 11, color: COLORS.MAIN_GRAY }}>
            {description}
          </span>
        )}
      </span>
    </label>
  );
}

export default FilterCheckbox;
